import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import KBYGPageContainer from '../containers/routes/KBYGPageContainer';
import { leaveSpotRoute } from '../actions/routes';
import { camsAndForecastsPaths } from '../utils/urls/camsAndForecastsPath';
import { spotForecastPaths } from '../utils/urls/spotForecastPath';
import { subregionForecastPaths } from '../utils/urls/subregionForecastPath';
import { subregionForecastChartsPaths } from '../utils/urls/subregionForecastChartsPath';

const importCamsAndForecasts = (nextState, cb) => {
  System.import('../containers/routes/CamsAndForecasts/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importGeonameMap = (nextState, cb) => {
  System.import('../containers/routes/GeonameMap/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importMap = (nextState, cb) => {
  System.import('../containers/routes/Map/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importSpotPage = (nextState, cb) => {
  System.import('../containers/routes/Spot/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importSpotReportPage = (nextState, cb) => {
  System.import('../containers/routes/Spot/SpotReportPage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importSpotForecastPage = (nextState, cb) => {
  System.import('../containers/routes/Spot/SpotForecastPage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importSubregionForecastPage = (nextState, cb) => {
  System.import('../containers/routes/SubregionForecastPage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importSubregionForecast = (nextState, cb) => {
  System.import('../containers/routes/SubregionForecastPage/SubregionForecast/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importPremiumAnalysis = (nextState, cb) => {
  System.import('../containers/routes/SubregionForecastPage/PremiumAnalysis/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importCharts = (nextState, cb) => {
  System.import('../containers/routes/SubregionForecastPage/Charts/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importNotFound = (nextState, cb) => {
  System.import('../containers/routes/NotFound/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const spotPath = `${spotForecastPaths.base}/:spotSlug/:spotId`;

const handleRouteChange = store => (prevState, nextState) => {
  if (prevState.routes[1].path === spotPath && nextState.routes[1].path !== spotPath) {
    store.dispatch(leaveSpotRoute());
  }
};

const routes = store => (
  <Route path="/" component={KBYGPageContainer} onChange={handleRouteChange(store)}>
    <Route path={camsAndForecastsPaths.base} getComponent={importCamsAndForecasts} />
    <Route path={`${camsAndForecastsPaths.base}-${camsAndForecastsPaths.map}(/@:location)`} getComponent={importMap} />
    <Route path={`${camsAndForecastsPaths.base}(/**)/:geonameId`} getComponent={importGeonameMap} />
    <Route path={spotPath} getComponent={importSpotPage}>
      <IndexRoute getComponent={importSpotReportPage} />
      <Route path={spotForecastPaths.forecast} getComponent={importSpotForecastPage} />
    </Route>
    <Route path={`${subregionForecastPaths.base}/:subregionName/:subregionId`} getComponent={importSubregionForecastPage}>
      <IndexRoute getComponent={importSubregionForecast} />
      <Route path={`${subregionForecastPaths.premiumAnalysis}(/**)`} getComponent={importPremiumAnalysis} />
    </Route>
    <Route path={`${subregionForecastChartsPaths.base}/:chartSlug/:subregionName/:subregionId`} getComponent={importSubregionForecastPage}>
      <IndexRoute getComponent={importCharts} />
    </Route>
    <Route path="*" getComponent={importNotFound} status={404} />
  </Route>
);

if (module.hot) {
  /* eslint-disable global-require */
  require('../containers/routes/CamsAndForecasts/index.js');
  require('../containers/routes/GeonameMap/index.js');
  require('../containers/routes/Map/index.js');
  require('../containers/routes/Spot/index.js');
  require('../containers/routes/Spot/SpotReportPage/index.js');
  require('../containers/routes/Spot/SpotForecastPage/index.js');
  require('../containers/routes/SubregionForecastPage/index.js');
  require('../containers/routes/SubregionForecastPage/SubregionForecast/index.js');
  require('../containers/routes/SubregionForecastPage/PremiumAnalysis/index.js');
  require('../containers/routes/NotFound/index.js');
  /* eslint-enable global-require */
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js